import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { checkIndustrialResource, checkUpgradeVisibility } from 'helpers/buildings'

import BuildingCardImage from 'components/BuildingCardImage/BuildingCardImage.jsx'

import {
    showUpgradeHighlight,
    hideUpgradeHighlight,
    openUpgradeConfirmation,
} from 'state/actions/building_upgrade'
import { getSortedProductionReserves } from 'helpers/reserves'

export class CardImage extends React.Component {
    static propTypes = {
        building: PropTypes.object.isRequired,
        tooltipId: PropTypes.string.isRequired,
        reserveQueue: PropTypes.arrayOf(PropTypes.object).isRequired,
        upgradeCost: PropTypes.number,
        hasEnoughIndustrialResource: PropTypes.bool.isRequired,
        showUpgrade: PropTypes.bool.isRequired,
        isUpgradeAvailable: PropTypes.bool.isRequired,

        handleMouseEnter: PropTypes.func.isRequired,
        handleMouseLeave: PropTypes.func.isRequired,
        handleClick: PropTypes.func.isRequired,
    }
    constructor(props) {
        super(props)
        this.state = { productionInProgress: false }
    }
    componentWillReceiveProps(nextProps) {
        this.processReserveQueue(nextProps.reserveQueue)
    }
    componentWillMount() {
        this.processReserveQueue(this.props.reserveQueue)
    }
    componentWillUnmount() {
        if (this.timerId) {
            clearTimeout(this.timerId)
        }
        this.props.handleMouseLeave()
    }
    processReserveQueue(reserveQueue) {
        if (this.timerId) {
            clearTimeout(this.timerId)
        }

        const productionEnds = reserveQueue.length ? reserveQueue[reserveQueue.length - 1].productionEnds : null
        const productionInProgress = !!productionEnds && (productionEnds > Date.now())

        if (productionInProgress) {
            this.timerId = setTimeout(this.processReserveQueue.bind(this, reserveQueue), productionEnds - Date.now())
        }

        this.setState({ productionInProgress })
    }
    render() {
        const {
            building,
            tooltipId,
            hasEnoughIndustrialResource,
            showUpgrade,
            isUpgradeAvailable,
            upgradeCost,

        } = this.props

        const upgradeAvailable = (
            !this.state.productionInProgress &&
            isUpgradeAvailable
        )

        return (
            <BuildingCardImage
                buildingType={building.type}
                buildingLevel={building.level}
                hasEnoughIndustrialResource={hasEnoughIndustrialResource}
                upgradeCost={upgradeCost}
                tooltipId={tooltipId}
                isUpgradeAvailable={upgradeAvailable}
                showUpgrade={showUpgrade}
                onMouseEnter={this.props.handleMouseEnter}
                onMouseLeave={this.props.handleMouseLeave}
                onClick={this.props.handleClick}
            />
        )
    }
}

export const mapStateToProps = (state, { building, reserveType, tooltipId }) => {

    const hasEnoughIndustrialResource = checkIndustrialResource(state, building)
    const showUpgrade = checkUpgradeVisibility(state, building)
    const nextLevelIsValid = ((building.level + 1) <= state.stronghold.level)

    const isUpgradeAvailable = (
        hasEnoughIndustrialResource &&
        showUpgrade &&
        nextLevelIsValid
    )

    const upgradeCost = state.settings.buildings[building.type].costs[building.level]
    const reserveQueue = getSortedProductionReserves(state.clanReserves[reserveType])

    return {
        tooltipId,
        building,
        upgradeCost,
        reserveQueue,
        hasEnoughIndustrialResource,
        showUpgrade,
        isUpgradeAvailable,
    }
}

export const mapDispatchToProps = {
    handleMouseEnter: showUpgradeHighlight,
    handleMouseLeave: hideUpgradeHighlight,
    handleClick: openUpgradeConfirmation,
}

export default connect(mapStateToProps, mapDispatchToProps)(CardImage)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/CardImage/CardImage.jsx